<template>
    <tbody>
        <tr class="ix-table-row-secondary">
            <th class="text-center">
                <div style="cursor: pointer;"> 
                    <i class="fas fa-chevron-down" v-show="!hidden" @click="hideRow"></i>
                    <i class="fas fa-chevron-up" v-show="hidden" @click="showRow"></i>
                </div>
              
            </th>
            <th class="text-left" style="padding: 10px;" :colspan="canEdit ? 2 : 3">Lot n° {{ lot.number }}
                <br>{{ lot.name }}
            </th>
            <td class="text-center align-middle">
                <div class="input-group input-group-sm" style="width: 200px !important; margin: 0 auto;">
                    <input type="number" class="form-control form-control-sm text-center"  v-if="canEdit"  :name="'lots[' + index + '][booked_quantity]'" v-model="lot.booked_quantity">
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary" type="button" id="button-addon2" :disabled="!canEdit" @click="updateArticlesQuantity()">Appliquer</button>
                    </div>
                </div>
            </td>
            <td class="text-center align-middle">
                {{ lot.booked_quantity_total }}
            </td>
            <td class="text-center align-middle">
                <input type="text" v-if="canEdit" style="width: 200px !important; margin: 0 auto;"  class="form-control form-control-sm text-center" text-center placeholder="jj/mm/aaaa" :name="'lots[' + index + '][booked_start_at]'" v-model="lot.booked_start_at" :id="'datepicker' + this.uniq">
            </td>
           
            <td class="text-right align-middle" v-if="canEdit">
                <span class="btn btn-sm transparent" @click="emitEventLineDeleted">
                    <i class="far fa-trash"></i>
                </span>
            </td>
        </tr>

        <booking-article-line
            v-show="!hidden"
            v-for="(article, articleIndex) in lot.booking_articles"
            :key="'lot-article-' + article.id"
            :index="articleIndex"
            :line="article"
            :can-edit="canEdit"
            @line-deleted="handleArticleDeleted">
        </booking-article-line>
        <tr v-if="lot.booking_articles && lot.booking_articles.length == 0">
            <td colspan="4" style="padding: 10px;">Aucun article trouvé</td>
        </tr>
    </tbody>
</template>

<script>
import BookingArticleLine from './BookingArticleLine.vue';
import $ from 'jquery'
import Swal from "sweetalert2";


export default {
    props: ['lot', 'index', 'canEdit'],
    components: {
        BookingArticleLine
    },
    data() {
        return {
            uniq : Math.random().toString(36).substr(2, 9),
            hidden : true,
        }
    },
    methods : {
        handleArticleDeleted(event) {
            this.$emit('line-deleted', event);
        },
        updateArticlesDates() {
            if (this.lot.booking_articles && this.lot.booking_articles.length > 0) {
                this.lot.booking_articles.forEach(article => {
                    article.booked_start_at = this.lot.booked_start_at;
                });
            }
        },
        updateArticlesQuantity() {
            // Sans quantité totale sur le lot, le prorata n'a pas de sens : on ne touche pas aux articles
            if (!this.lot.booked_quantity_total || this.lot.booked_quantity_total == 0) {
                return;
            }

            if (this.lot.booking_articles && this.lot.booking_articles.length > 0) {
                this.lot.booking_articles.forEach(article => {
                    article.booked_quantity =  ((this.lot.booked_quantity / this.lot.booked_quantity_total) *  article.booked_quantity_total).toFixed(2);
                });
            }
        },
        parseDate(dateStr) {
            if (!dateStr) return null;
            const [day, month, year] = dateStr.split('/');
            return new Date(year, month - 1, day);
        },
        emitEventLineDeleted: function () {
            Swal.fire({
                title: 'Êtes-vous sûr de supprimer le lot ? Le contenus associé sera également supprimé ?',
                text: "",
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Annuler',
                confirmButtonColor: '#D15240',
                confirmButtonText: 'Oui, supprimer',
                reverseButtons: true,
                heightAuto: false
            }).then((result) => {
                if (result.value) {
                    this.$emit('line-deleted', {'booking_lot_id' : this.lot.id})
                }
            })
        },
        hideRow() {
            this.hidden = true;
        },
        showRow() {
            this.hidden = false;
        }
    },
    watch: {
        'lot.booked_start_at': {
            handler(newValue) {
                if (newValue !== undefined && newValue !== null) {
                    this.updateArticlesDates();
                }
            }
        },
    },
    mounted(){
        $("#datepicker"  + this.uniq).datepicker({
            format: "dd/mm/yyyy",
            todayBtn: true,
            language: "fr",
            calendarWeeks: true,
            autoclose: true,
            todayHighlight: true,
            clearBtn: false,
            startDate: new Date()
        })

        $("#datepicker"  + this.uniq).change(function() {
            $(this)[0].dispatchEvent(new Event('input'));
        });     
        
    }
}
</script>


